import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiDomainService } from '@app/core/http/api-domain/api-domain.service';
import { LoadingService } from '@app/core/services/loading/loading.service';
import { SharedService } from '@app/core/services/shared/shared.service';
import { AuthProviders, AuthProvidersTypes } from '@app/shared/models/AuthProviders';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-identity-provider-login',
  templateUrl: './identity-provider-login.component.html',
  styleUrls: ['./identity-provider-login.component.scss'],
})
export class IdentityProviderLoginComponent implements OnInit {

  form: FormGroup;
  ldapProviderAvail = false;
  internalProviderAvail = false;
  sirsiPolarisProviderAvail = false;
  innovativeProviderAvail = false;
  @Input() set provider(value) {
    this.ldapProviderAvail = value === AuthProvidersTypes.ldap.toLowerCase();
    this.sirsiPolarisProviderAvail = value === AuthProvidersTypes.sirsi.toLowerCase() || value === AuthProvidersTypes.polaris.toLowerCase();
    this.innovativeProviderAvail = value === AuthProvidersTypes.innovative.toLowerCase();
    this.internalProviderAvail = value === AuthProvidersTypes.internal.toLowerCase();
  }
  
  @Input() private authData: AuthProviders;

  constructor(
    private loadingSvc: LoadingService,
    private apiDomainSvc: ApiDomainService,
    private modalCtrl: ModalController,
    private sharedSvc: SharedService,
    private translateService: TranslateService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {

    this.form = new FormGroup({
      username: new FormControl('', {
        updateOn: "change",
        validators: [Validators.required],
      }),
      password: new FormControl('', {
        updateOn: "change",
        validators: [Validators.required],
      }),
    });
    this.manageFormControl();
  }

  manageFormControl(){
    if(this.sirsiPolarisProviderAvail || this.innovativeProviderAvail){
      this.form.removeControl('username');
      this.form.addControl('barcode',  this.fb.control('', {
        updateOn: "change",
        validators: [Validators.required],
      }));
    } 
    if(this.innovativeProviderAvail){
      this.form.removeControl('password');
      this.form.addControl('pin',  this.fb.control('', {
        updateOn: "change",
        validators: [Validators.required],
      }));
    }
  }

  async onSubmit() {    
    if(!this.sharedSvc?.getCustomerDetails || !this.authData || this.form.invalid){
      return;
    }
    await this.loadingSvc.present(this.translateService.instant("LOADING"));
    this.internalProviderAvail ? this.internalLogin() : this.otherProviderLogin()
  }

  async otherProviderLogin(){
    const formData =  {
      ...this.form.value,
      orgId : this.authData.OrgID,
      authId: this.authData._id
    }
    try {
      const response = await this.apiDomainSvc.identityProviderLogin(formData);
      const hashId = response?.data?.hashId || response?.data?.HashID
      if (response?.status && hashId) {
        this.modalCtrl.dismiss(hashId)
      }
    } finally {
      await this.loadingSvc.dismiss();
    }
  }

  async internalLogin(){
    const formData = {
      userName: this.form.value.username,
      password: this.form.value.password
    }
    try {
      const response = await this.apiDomainSvc.internalLogin(formData);
      if (response?.status && response?.data) {
        const res = {...response?.data}
        res.userName = formData.userName;
        this.modalCtrl.dismiss(res)
      }
    } finally {
      await this.loadingSvc.dismiss();
    }
  }
}
